export default "__VITE_ASSET__CaQ5afhl__"